import { Dispatch, SetStateAction } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { CustomValidationError } from "go-form/services/types";
import { CsvImportOverviewFormType, ImportOverviewFormSelects } from "../../../../../services/types";
import ImportOverviewRequiredSearchSelect from "./ImportOverviewRequiredSearchSelect";

interface Props {
	form: UseFormReturn<CsvImportOverviewFormType>;
	formSelects: ImportOverviewFormSelects[];
	setErrors: Dispatch<SetStateAction<CustomValidationError<CsvImportOverviewFormType>[]>>;
}

const ImportOverviewForm = ({ form, formSelects, setErrors }: Props) => {
	const {
		control,
		formState: { errors },
	} = form;

	return (
		<div className="row csv-import-inputs">
			{formSelects.map((formSelect) => {
				const { isRequired, id, label, options } = formSelect;
				return (
					<div key={id} className="col-md-4">
						{isRequired ? (
							<ImportOverviewRequiredSearchSelect
								formSelect={formSelect}
								form={form}
								setErrors={setErrors}
							/>
						) : (
							<FormSelectGroup
								name={id}
								control={control}
								label={label}
								options={options}
								errors={errors}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default ImportOverviewForm;
